<template>
  <div class="gasTest">
    <div class='wrapHeader'>
      <el-form :inline="true" :model="wareInfo" class="demo-form-inline">
        <el-form-item label="仓房选择">
          <el-select v-model="wareInfo.wareId" @change='wareIdChange' placeholder="仓房选择">
            <el-option :label="item.wareName" :value="item.wareId" v-for='item in wareList' :key='item.wareId'></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="setBgImg" :style="`height:${height}px`">
      <div class="showView" :style="`height:${height-20}px;width:${width-30}px`">
        <el-button type="primary" icon="el-icon-refresh" class="commonBtn clearError" plain @click="clearError">清除故障</el-button>
        <div class='setMacView' :style="`height:${height-100}px;width:${width-60}px`">
          <div class='gasInfoWrap'>
            <div class='gasInfo'>
              <div class='header'>
                <div class='gasTitle'>{{gasInfo.wareName}}气体浓度实时信息</div>
              </div>
              <div class='gasWrap'>
                <div class="gasItem"><span class='gasName'>氧气浓度</span>：<span class='gasVal'>{{gasInfo.o2}}</span>&nbsp;&nbsp;%</div>
                <div class="gasItem"><span class='gasName'>磷化氢浓度</span>：<span class='gasVal'>{{gasInfo.ph3}}</span>&nbsp;&nbsp;ppm</div>
                <div class="gasItem"><span class='gasName'>硫酰氟浓度</span>：<span class='gasVal'>{{gasInfo.so2f2}}</span>&nbsp;&nbsp;ppm</div>
                <div class="gasItem"><span class='gasName'>氧气浓度上限报警</span>：<span :class='["gasStatus",gasInfo.status==0?"offLine":(gasInfo.errorO2Max==0?"normal":"fault")]'></span></div>
                <div class="gasItem"><span class='gasName'>氧气浓度下限报警</span>：<span :class='["gasStatus",gasInfo.status==0?"offLine":(gasInfo.errorO2Min==0?"normal":"fault")]'></span></div>
                <div class="gasItem"><span class='gasName'>磷化氢浓度上限报警</span>：<span :class='["gasStatus",gasInfo.status==0?"offLine":(gasInfo.errorPh3Max==0?"normal":"fault")]'></span></div>
                <div class="gasItem"><span class='gasName'>磷化氢浓度下限报警</span>：<span :class='["gasStatus",gasInfo.status==0?"offLine":(gasInfo.errorPh3Min==0?"normal":"fault")]'></span></div>
                <div class="gasItem"><span class='gasName'>硫酰氟浓度上限报警</span>：<span :class='["gasStatus",gasInfo.status==0?"offLine":(gasInfo.errorSo2f2Max==0?"normal":"fault")]'></span></div>
                <div class="gasItem"><span class='gasName'>硫酰氟浓度下限报警</span>：<span :class='["gasStatus",gasInfo.status==0?"offLine":(gasInfo.errorSo2f2Min==0?"normal":"fault")]'></span></div>
                <div>
                  <ul class='gasTip'>
                    <li>警告：</li>
                    <li>当氧气低于19.5%禁止人员进去仓内；磷化氢浓度低于50ppm方可开仓通风；磷化氢浓度高于0.2ppm禁止人员进入仓内；硫酰氟浓度低于5ppm方可开仓通风，浓度高于4.39ppm禁止人员进入仓内。。</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios.js'
import createSocket from '../../webSocket.js'
export default {
  props:{
    width:Number,
    height:Number
  },
  data(){
    return{
      wareInfo:{
        wareId:''
      },
      wareList:[],
      gasInfo:{},
      ws:null
    }
  },
  created(){
    this.getWareList()
  },
  destroyed(){
    this.ws.close()
  },
  methods:{
    socket(){
      this.ws=createSocket('/websocket/gasInfo')
      this.ws.onmessage=this.wsMessage;
    },
    getWareList(){
      axios.get('/system/house/getHouseSelect').then(res=>{
        if(res){
          this.wareList=res.data;
          this.wareInfo.wareId=res.data[0].wareId;
          this.getGasInfo()
        }
      })
    },
    wareIdChange(){
      this.getGasInfo()
    },
    getGasInfo(){
      if(!this.ws||this.ws.readyState==3){
        this.socket()
        this.sendId()
      }else{
        this.sendId()
      }
      axios.get(`/system/gas/getGasByWareId/${this.wareInfo.wareId}`).then(res=>{
        if(res){
          this.gasInfo=res.data;
        }
      })
    },
    sendId(){
      if(this.ws.readyState===1){
        this.ws.send(this.wareInfo.wareId);
      }else{
        setTimeout(()=>{
          this.sendId()
        },500)
      }
    },
    clearError(evt){
      let target = evt.target;
      if(target.nodeName == "SPAN"){
        target = evt.target.parentNode;
      }
      target.blur();
      axios.post('/system/gas/clearError',{serId:this.gasInfo.serId}).then(res=>{
        if(res){
          this.$message({
            message:'清除成功！',
            type:'success',
            duration:1000
          })
        }
      })
    },
    wsMessage(res){
      let data=JSON.parse(res.data);
      this.gasInfo=data;
    }
  }
}
</script>

<style lang="scss" scoped>
.gasTest{
  .clearError{
    left: 15px;
  }
  .gasInfoWrap{
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .gasInfo{
      height: 700px;
      width:1000px;
      border: 1px solid rgba(0,0,0,.1);
      display: flex;
      flex-direction: column;
      .header{
        background-color: rgba(48,56,255,0.03);
        height: 50px;
        line-height: 50px;
        font-weight: 600;
        font-family: 'xingshu';
        font-size: 20px;
        padding-left: 20px;
        border-bottom: 1px solid rgba(0,0,0,.1);
        .gasTitle{
          background: linear-gradient(to right, #08a3d3, #0066ba);
          -webkit-background-clip: text;
          color: transparent; 
        }
      }
      .gasWrap{
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        padding:10px 50px;
        box-sizing: border-box;
        .gasItem{
          display: flex;
          align-items: center;
          width: 400px;
          font-weight: 600;
          font-size: 16px;
          background: linear-gradient(to right, #08a3d3, #0066ba);
          -webkit-background-clip: text;
          color: transparent;
          .gasName{
            width: 150px;
            display: inline-block;
            text-align: end;
            line-height: 50px;
            height: 50px;
            font-family: "楷体"
          }
          .gasVal{
            display: inline-block;
            border: 1px solid rgba(0,0,0,.1);
            height: 50px;
            line-height: 50px;
            width: 120px;
            text-align: center;
            font-family: 'led';
            font-size: 48px;
            font-weight: 400;
            color: black
          }
          .gasStatus{
            height: 40px;
            width: 40px;
            background-size: cover;
            margin-left: 40px
          }
          .normal{
            background-image: url('../../assets/icon/green.png')
          }
          .fault{
            background-image: url('../../assets/icon/red.png')
          }
          .offLine{
            background-image: url('../../assets/icon/grey.png');
          }
        }
        .gasTip{
          width: 600px;
          font-size: 12px;
          font-style:italic;
          color: red
        }
        
      }
    }
  }
  
}
</style>
